const QUOTES = [
    {
        text: "Pehle mahine ke end mein pata chalta tha ki cash kya tha. Ab subah uthke phone dekhta hun aur sab numbers saamne hain.",
        name: "Rajesh Sharma",
        meta: "Crestline Industries · Delhi, India",
        initials: "RS",
    },
    {
        text: "The GST ITC reconciliation saved us ₹2.4 lakhs in the first month. Two suppliers were not filing and we had no idea.",
        name: "Anita Iyer",
        meta: "Helix Auto Components · Bangalore, India",
        initials: "AI",
    },
    {
        text: "We run three trading entities across the GCC. C-ORE consolidated all of them onto one boardroom — cash, debtors, margins, everything. The CFO module alone replaces two full-time analysts for us.",
        name: "Aditya Khanna",
        meta: "Meridian Trading Group · Dubai, UAE",
        initials: "AK",
    },
    {
        text: "Switching our boardroom to C-ORE was the cleanest onboarding I have seen for any analytics tool. Five minutes and our P&L, runway, and growth pipeline were live in one place.",
        name: "James Tan",
        meta: "Harbor Asia Pte Ltd · Singapore",
        initials: "JT",
    },
    {
        text: "We compete with companies ten times our size. C-ORE gives us the same boardroom intelligence they have — for a fraction of the cost. My board pack literally writes itself now.",
        name: "Sarah Mitchell",
        meta: "Thameside Imports · London, UK",
        initials: "SM",
    },
];

const TRUST = [
    { num: "₹2.4L+", lbl: "average ITC saved first month" },
    { num: "18 days", lbl: "average to first insight" },
    { num: "4.8/5", lbl: "customer satisfaction" },
];

function StarIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2.5l2.9 6.2 6.7.8-4.9 4.6 1.3 6.6-6-3.4-6 3.4 1.3-6.6-4.9-4.6 6.7-.8z" />
        </svg>
    );
}

export default function SocialProof() {
    return (
        <section className="testimonials" data-testid="v2-social-proof">
            <div className="container">
                <div className="testimonials__head reveal">
                    <span className="testimonials__eyebrow">
                        What business owners say
                    </span>
                    <h2 className="testimonials__title">
                        Real results, across the globe.
                    </h2>
                </div>
                <div className="testimonial__grid">
                    {QUOTES.map((q, i) => (
                        <div
                            className="testimonial__card reveal"
                            key={i}
                            data-testid={`v2-testimonial-${i}`}
                        >
                            <div
                                className="testimonial__stars"
                                aria-label="5 out of 5 stars"
                            >
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <div className="testimonial__text">
                                &ldquo;{q.text}&rdquo;
                            </div>
                            <div className="testimonial__who">
                                <div className="testimonial__avatar">
                                    {q.initials}
                                </div>
                                <div>
                                    <div className="testimonial__name">
                                        {q.name}
                                    </div>
                                    <div className="testimonial__meta">
                                        {q.meta}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="trust__row">
                    {TRUST.map((t, i) => (
                        <div
                            className="trust__item reveal"
                            key={i}
                            data-testid={`v2-trust-${i}`}
                        >
                            <div className="trust__num">{t.num}</div>
                            <div className="trust__lbl">{t.lbl}</div>
                        </div>
                    ))}
                </div>
                <p className="testimonials__line reveal" data-testid="v2-trust-line">
                    Trusted by 100+ CAs and 500+ Consultants
                </p>
            </div>
        </section>
    );
}
